import { render, staticRenderFns } from "./TeamEmblem.vue?vue&type=template&id=ac73e036&"
import script from "./TeamEmblem.vue?vue&type=script&lang=js&"
export * from "./TeamEmblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports